import { useState } from "react";

const useSelectedStudents = ({
	studentList, reservation,
}) => {
    const [selectedStudents, setSelectedStudents] = useState([]);
	function allStudentsAreSelected() {
        return studentList.value.every(currentStudent => selectedStudents.some(({ id }) => currentStudent.id === id));
    }
	function studentIsSelected(student) {
        return selectedStudents.some(({ id }) => id === student.id);
    }
	function manyStudentsAreSelected(studentIds) {
		return selectedStudents.some(({ id }) => studentIds.includes(id));
    }
	function noSelected() {
		return selectedStudents.length === 0;
	}
	function onlyOneStudentSelected() {
		return selectedStudents.length === 1;
	}
	function allSelected() {
		return selectedStudents.length === studentList.value.length;
	}
	function minCapacityHasBeenReached() {
        return !allSelectedStudentsAreNotSaved() && 
			studentList.value.length - selectedStudents.length < reservation.space.minCapacity;
    }
	function allSelectedStudentsAreNotSaved() {
		return selectedStudents.every(({ saved }) => !saved);
	}
	function checkIfHasBeenSelectedResponsibleStudent() {
        return selectedStudents.some(({ id }) => id === reservation.students.responsible.id);
    }
	function toggleAllStudentsSelection() {
        setSelectedStudents(allStudentsAreSelected() ? [] : [...studentList.value]);
    }
	const toggleStudentSelected = student => {
        setSelectedStudents(
            studentIsSelected(student)
                ? selectedStudents.filter(({ id }) => id !== student.id)
                : [...selectedStudents, student]
        );
    }
	function getReservationDetailsIdsOfStudentsSelected() {
		return studentList.value
			.filter(currentStudent => selectedStudents.some(({ id }) => currentStudent.id === id))
			.map(({ reservationDetailId }) => reservationDetailId)
	}
	function getSavedSelectedStudents() {
		return selectedStudents.filter(({ reservationDetailId }) => reservationDetailId);
	}
	function getSelectedStudentsFromList() {
		return studentList.value
			.filter(currentStudent => selectedStudents
			.some(({ id }) => currentStudent.id === id));
	}
	function unselectAllStudents() {
        setSelectedStudents([]);
	}
	function updateDataOnlySelectedStudentsOfList(data) {
		return studentList.value.map(currentStudent => {
            if (selectedStudents.some(({ id }) => currentStudent.id === id)) 
                return {
                    ...currentStudent,
					...data
                };
            return { ...currentStudent };
        });
	}
	function markForTakeAttendanceOnlySelectedStudents() {
        studentList.update(
			updateDataOnlySelectedStudentsOfList({
				forTakeAttendance: true
			})
		);
	}
	function markForPenalizeOnlySelectedStudents() {
		studentList.update(
			updateDataOnlySelectedStudentsOfList({
				forPenalize: true
			})
		);
	}
	function removeSelectedStudentsFromList() {
		studentList.update(
            studentList.value
          	  .filter(currentStudent => !selectedStudents.some(({ id }) => currentStudent.id === id))
		);
	}
	function getStudentIds() {
		return selectedStudents.map(({ id }) => id);
	}
	function getReservationDetailIds() {
		return selectedStudents.map(({ reservationDetailId }) => reservationDetailId);
	}
	function getStudentPenaltyIds() {
		return selectedStudents
			.filter(({ penalty }) => penalty)
			.map(({ penalty }) => penalty.studentPenalizedId);
	}
	function getFirstSelectedStudent() {
		return selectedStudents[0];
	}
	function getReservationDetailIdsWithoutPenalty() {
		return selectedStudents
			.filter(({ penalty }) => !penalty)
			.map(({ reservationDetailId  }) => reservationDetailId);
	}
	function existStudentsForPenalize() {
		return selectedStudents.every(({ penalty, forPenalize }) => penalty || forPenalize);
	}
	function studentWithReservationDetailIdIsSelected(reservationDetailId) {
        return selectedStudents.some(currentStudent => currentStudent.reservationDetailId === reservationDetailId);
    }
	function studentWithPenalizedIdIsSelected(studentPenalizedId) {
        return selectedStudents.some(currentStudent => currentStudent.studentPenalizedId === studentPenalizedId);
    }
	function existSelectedStudentsNotSaved() {
        return selectedStudents.some(({ saved }) => !saved);
	}
	function allStudentsHaveAttendance() {
        return selectedStudents.every(({ attended }) => attended);
    }
	return {
		value: selectedStudents,
		getSelectedStudentsFromList,
		allSelected, noSelected, studentIsSelected,
		allAreSelected: allStudentsAreSelected,
		studentWithReservationDetailIdIsSelected,
		studentWithPenalizedIdIsSelected,
		manyStudentsAreSelected,
		onlyOneStudentSelected,
		checkIfHasBeenSelectedResponsibleStudent,
		toggleAll: toggleAllStudentsSelection,
		toggleStudentSelected,
		getReservationDetailsIdsOfStudentsSelected,
		unselectAllStudents,
		getStudentIds,
		getFirstSelectedStudent,
		getReservationDetailIds,
		getSavedSelectedStudents,
		getStudentPenaltyIds,
		getReservationDetailIdsWithoutPenalty,
		existStudentsForPenalize,
		existSelectedStudentsNotSaved,
		allStudentsHaveAttendance,
		markForTakeAttendanceOnlySelectedStudents,
		markForPenalizeOnlySelectedStudents,
		removeSelectedStudentsFromList,
		minCapacityHasBeenReached
	};
}	
	
export default useSelectedStudents;